var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"src":_vm.pic1,"alt":""}}),_c('img',{attrs:{"src":_vm.pic2,"alt":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',[_c('a',{staticStyle:{"color":"#2c3e50","text-decoration":"none"},attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("粤ICP备13053897号")])]),_vm._v(" Copyright ©2025 - 广州市润心文化有限公司")])
}]

export { render, staticRenderFns }